(function () {
  angular.module("akitabox.ui.dialogs.room.create", [
    "ngMaterial",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.flag",
    "akitabox.core.services.pinType",
    "akitabox.core.services.pinField",
    "akitabox.core.services.room",
    "akitabox.core.toast",
  ]);
})();
